import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, Input, FormGroup, Label, Modal, Form, Button } from 'reactstrap';
import "../../modules/patient/PatientProfile.css";
import Loader from '../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../utils/Tostify';
import { saveFilter } from '../../api/filters';
import { useEffect } from 'react';
import { DepartmentOptions, medicaidOptions, yesNoMedicaidOptions, yesNoOptions } from '../../modules/patient/Constant';
import { applicationStatus, supportStatus } from '../../modules/applications/Constant';
import { useGetStates } from '../../hooks/useGetStates';
import { setSelectedCustomFilter } from '../../context/reducers/pagination';
import { setSelectedCustomFilters } from '../../context/reducers/adminApplnState';

const DynamicFilterDropdown = ({ onFilterChange, type, selectedFilters, columnOptions, staffList, refetch}) => {
  const [dropdowntwo, setDropdownTwo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveNewView, setSaveNewView] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterTitle, setFilterTitle] = useState('');
  const { states } = useGetStates("US");
  const [stateList, setStateList]=[
    states.map((obj) => {
      return {
        label: obj.name,
        value: obj.name
    };})
  ];
  const dispatch = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  let user = useSelector((state) => state.userReducer.user);

  const [filters, setFilters] = useState(selectedFilters || [
    { condition: 'Where', field: columnOptions[0].value, operator: 'is', value: 'None' }
  ]);

  const Filter_Func = (columns) => {
    return columns.map(column => {
      let conditionOptions = [];
      let userInput = null;

      if (column.dataType === 'Date') {
        conditionOptions = ['Less than', 'Is', 'Is Not', 'Greater than'];
        userInput = 'Date';
      } else if (column.dataType === 'Bool') {
        conditionOptions = ['Is', 'Is Not'];
        userInput = [true, false]; // True/False options
      } else if (column.dataType === 'Numeric') {
        if (column.isEnum) {
          conditionOptions = ['Is', 'Is Not'];
          userInput = column.enumValues; // List of ENUM values
        } else {
          conditionOptions = ['Less than', 'Is', 'Is Not', 'Greater than'];
          userInput = 'Text Box or Int/Numeric'; // Modify to use appropriate input types
        }
      } else if (column.dataType === 'String') {
        if (column.isEnum) {
          conditionOptions = ['Is', 'Is Not'];
          userInput = column.enumValues; // List of ENUM values
        } else {
          conditionOptions = ['Is', 'Is Not'];
          userInput = 'Text Box or String'; // Modify as needed
        }
      } else if (column.dataType === 'Search_String') {
        conditionOptions = ['Contains', 'Not Contains'];
        userInput = 'Text Box or String'; // Modify as needed
      }else {
        console.warn(`Unsupported data type: ${column.dataType}`);
      }

      return {
        field: column.value, // Use the value of the column for filtering
        conditionOptions,
        userInput
      };
    });
  };

  useEffect(() => {
    if(selectedFilters){
     setFilters(selectedFilters);
    }
  }, [selectedFilters]);

  const toggleDropdown = () => setDropdownTwo(!dropdowntwo);

  const handleFilterChange = (index, key, value) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    if (key === 'field') {
        newFilters[index].operator = getDefaultOperator(value);
    }
    setFilters(newFilters);
  };

  const getDefaultOperator = (field) => {
    // Return default operator based on field selection
    if (field === 'household_salary') {
      return 'Less than';
    } else {
      return 'is';  // Default operator for other fields
    }
  };

  const addFilter = () => {
    const condition = filters.length === 0 ? "Where" : "And";
    setFilters([...filters, { condition: condition, field: columnOptions[0].value, operator: 'is', value: '' }]);
  };

  const removeFilter = (index) => {
    setFilters(filters.filter((_, i) => i !== index));
    dispatch(setSelectedCustomFilter(null));
    dispatch(setSelectedCustomFilters(null));
  };

  const handleSave = () => {
    onFilterChange(filters);  // Pass filters to parent
  };

  // Get operator options based on selected field
  const getOperatorOptions = (field) => {
    const column = columnOptions.find(col => col.value === field);
    if (!column) return [];

    // Call Filter_Func to get options based on the found column
    const filterOptions = Filter_Func([column]); // Pass the found column as an array
    return filterOptions.length > 0 ? filterOptions[0].conditionOptions : []; // Return the conditionOptions
  };

  const statusOptions = type === "Support" ? supportStatus : applicationStatus;

  // Render input field dynamically based on selected field
  const renderInputField = (field, value, index,filter) => {
    const column = columnOptions.find(col => col.value === filter.field);
    if (!column) return null;
    if (column.dataType === 'Numeric') {
      return (
        <Input
          type="number"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        />
      );
    }
    if (column.dataType === 'Date') {
      return (
        <Input
          type="date"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        />
      );
    }
    if (field === 'discharged_status' || field === 'coverage' || field === 'pregnant' || field === 'disable') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {yesNoOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'department_approval') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {DepartmentOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'assigned_to' || field === 'createdBy') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {staffList.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'assignedTo' && type === "Support") {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {staffList
            .filter((item) =>
              item?.roleDetails?.some(role => role.portalLayout === "Platform" && role.active)
            )
            .map((obj) => (
              <option key={obj?._id} value={obj?._id}>
                {`${obj?.label || 'No Role'})`}
              </option>
            ))}
        </Input>
      );
      }
    if (field === 'Application Type') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option>Enrollment</option>
          <option>Processing</option>
          <option>Completed</option>
        </Input>
      );
    }
    if (field === 'medicaid_eligibility') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {yesNoMedicaidOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'group_eligibility') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {medicaidOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'status') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    if (field === 'state') {
      return (
        <Input
          type="select"
          id="exampleSelect"
          value={value}
          onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
        >
          <option value="">Select</option>
          {stateList.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }
    return (
      <Input
        type="text"
        id="exampleSelect"
        value={value}
        onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
      />
    );
  };

  const handleSaveFilter = () => {
    const newState = !saveNewView;
    setSaveNewView(newState);
    if (newState) {
        setIsModalOpen(true); // Open modal immediately when toggling to true
    }
};

 const handleSaveNewFilter = async () => {
    if (!filterTitle) {
      failed('Please enter a title for the filter!');
      return;
    }

    let res;
    try {
      let values = { filters, filterType: type, userId: user._id, title: filterTitle };
      setIsLoading(true);
      res = await saveFilter({ values, dispatch, token });
      if (res?.status === 'SUCCESS') {
        setIsLoading(false);
        success(res?.message);
        setSaveNewView(false);
        await refetch();
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed('Error saving the filter');
    }
    setIsModalOpen(false); // Close the modal after save
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
  };

  const isDropdownVisible = filters.length > 0 && filters.some(f => f.field);

  const isSaveEnabled = isDropdownVisible && filters.every(
    (filter) =>
      filter.field &&
      filter.operator &&
      filter.value !== undefined &&
      filter.value !== null &&
      filter.value !== '' &&
      filter.value !== 'None'
  );

  return (
    <>
    <div>
        {isLoading ? <Loader /> : null}
        <Dropdown isOpen={dropdowntwo} toggle={toggleDropdown}>
        <DropdownToggle caret size="xl" className="filter_block">
            Filter By <i className="fa fa-caret-down"></i>
        </DropdownToggle>
        <DropdownMenu>
            <div className="sorted_filter">
            {filters?.map((filter, index) => (
                <div key={index} className="row first_blk align-items-center">
                <div className="col-xxl-11">
                    <div className="row align-items-center">
                    <div className="col-xxl-3 col-lg-6 mb-2">
                        {filters.length === 1 || index === 0 ? (
                          <>Where</>
                        ) : (
                          <FormGroup>
                            <Input
                              id="exampleSelect"
                              type="select"
                              value={filter.condition}
                              onChange={(e) => handleFilterChange(index, 'condition', e.target.value)}
                            >
                                <>
                                  <option value="And">And</option>
                                  <option value="Or">Or</option>
                                </>
                            </Input>
                          </FormGroup>
                        )}
                      </div>
                    <div className="col-xxl-3 col-lg-6 mb-2">
                    <FormGroup>
                        <Input
                          type="select"
                          id="exampleSelect"
                          value={filter.field}
                          onChange={(e) => handleFilterChange(index, 'field', e.target.value)}
                        >
                          {columnOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </div>
                    <div className="col-xxl-3 col-lg-6 mb-2">
                        <FormGroup>
                        <Input
                            id="exampleSelect"
                            type="select"
                            value={filter.operator}
                            onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                        >
                            <option value="">Select Condition</option>
                                {getOperatorOptions(filter.field).map((option, i) => (
                                  <option key={i} value={option}>
                                    {option}
                                  </option>
                                ))}
                        </Input>
                        </FormGroup>
                    </div>
                    <div className="col-xxl-3 col-lg-6 mb-2">
                        <FormGroup>
                        {renderInputField(filter.field, filter.value, index,filter)}
                        </FormGroup>
                    </div>
                    </div>
                </div>
                <div className="col-xxl-1">
                    <i className="fas fa-trash-alt" onClick={() => removeFilter(index)}></i>
                </div>
                </div>
            ))}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 button_fil">
                <div>
                  <Button
                      color={saveNewView ? "primary" : "secondary"}
                      onClick={(e) => handleSaveFilter({ target: { checked: !saveNewView } })}
                      disabled={!isSaveEnabled}
                  >
                      Save as New View
                  </Button>
              </div>
                <button className="add_filter_blk" onClick={addFilter}>
                Add Filter
                </button>
                <button className="Save_btn" onClick={handleSave}>
                Apply
                </button>
            </div>
            </div>
        </DropdownMenu>
        </Dropdown>
        {isModalOpen &&
         <Modal isOpen={isModalOpen} toggle={handleModalClose}>
         <Form>
           <div className="modal-header">
             <h5 className="modal-title">Save Filter</h5>
             <button type="button" className="close" onClick={handleModalClose}>
               <span>&times;</span>
             </button>
           </div>
           <div className="modal-body">
             <FormGroup>
               <Label for="filterTitle">Filter Title</Label>
               <Input
                 type="text"
                 name="filterTitle"
                 id="filterTitle"
                 placeholder="Enter title for this filter"
                 value={filterTitle}
                 onChange={(e) => setFilterTitle(e.target.value)}
               />
             </FormGroup>
           </div>
           <div className="modal-footer">
             <Button color="secondary" onClick={handleModalClose}>
               Cancel
             </Button>
             <Button color="primary" onClick={handleSaveNewFilter}>
               Save Filter
             </Button>
           </div>
         </Form>
       </Modal>
       }
       </div>
       </>
     );
   };

export default DynamicFilterDropdown;
